<mat-dialog-content>
  <p class="mb-0" data-testid="remove-emaac-item-message">{{ data.messageKey | translate }}</p>
</mat-dialog-content>
<mat-dialog-actions class="ml-3 mb-3">
  <button class="btn btn-outline-danger mr-2" (click)="confirm()" data-testid="remove-emaac-item-confirm">
    <span class="fa-light fa-fw fa-trash-alt"></span> {{ 'CONFIRM' | translate }}
  </button>
  <button class="btn btn-outline-dark" (click)="cancel()" data-testid="remove-emaac-item-cancel">
    {{ 'CANCEL' | translate }}
  </button>
</mat-dialog-actions>
